import React, {useEffect, useState} from "react";
import { useOrderContext } from "../../hooks/useContext/useOrderContext";
import { Typography, Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SimpleAlert from '../Shared/Alert';
import useFetchOpenStatus from "../../hooks/useFetchOpenStatus";
import { useAvailableItemConfigContext } from "../../hooks/useContext/useAvailableItemConfigContext";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';


function FeatureCard(props) {
  const storeClosedText = "Przepraszamy, obecnie jesteśmy zamknięci!";
  const addToCartText = "Pomyślnie dodano do koszyka!";
  const { dispatch } = useOrderContext();
  const theme = useTheme();
  const { itemId, itemImage, itemName, itemType, itemDetails, itemIncludes, itemAvailable, expanded, onExpand} = props;
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [showAlert, setShowAlert] = useState(false);
  const { openStatus } = useAvailableItemConfigContext();

  useFetchOpenStatus();

  const handleExpandClick = () => {
    onExpand();
  };

  useEffect(() => {
    if (itemDetails.length === 1) {
      setSelectedSize(itemDetails[0].itemSize);
      setSelectedPrice(itemDetails[0].itemPrice);
    } else {
      const largeDetail = itemDetails.find(detail => detail.itemSize === 'Duże');
      setSelectedSize(largeDetail ? 'Duże' : itemDetails[0].itemSize);
      setSelectedPrice(largeDetail ? largeDetail.itemPrice : itemDetails[0].itemPrice);
    }
  }, [itemDetails]);


  const handleSizeChange = (size, event) => {
    setSelectedSize(size);
    const price = itemDetails.find(detail => detail.itemSize === size)?.itemPrice;
    setSelectedPrice(price);
    event.stopPropagation();
  };


  const incrementQuantity = (event) => {
    setQuantity(prev => prev + 1);
    event.stopPropagation();
  };


  const decrementQuantity = (event) => {
    setQuantity(prev => (prev > 1 ? prev - 1 : 1));
    event.stopPropagation();
  };


  const addItemToOrder = (event) => {
    dispatch({
      type: 'ADD_ORDER',
      payload: {
        _id: itemId,
        itemName,
        itemImage,
        itemType,
        itemSize: selectedSize,
        itemPrice: selectedPrice,
        itemIncludes,
        itemAvailable,
        itemQuantity: quantity,
      }
    });
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 1400)
    setQuantity(1);
    event.stopPropagation();
  };


  return (
    <div>
      {openStatus === false && <SimpleAlert text={storeClosedText} showAlert={!openStatus} type={"error"} />}
      {showAlert && <SimpleAlert text={addToCartText} showAlert={showAlert} type={"success"} />}
      

      <Card onClick={handleExpandClick} sx={{ margin:".5rem", background: theme.palette.component.componentBackground }}>
        <CardHeader
          avatar={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <Typography variant="h2" gutterBottom>
                {selectedPrice}
              </Typography>
              <Typography variant="h3" gutterBottom>
                zł
              </Typography>
            </Box>
          }
          title={itemName}
          // subheader={itemIncludes}
        />
          <Box sx={{ position: 'relative' }}>
            {itemImage && (
              <CardMedia
                component="img"
                height={expanded ? "max" : "194px"}
                image={itemImage}
                alt={itemName}
                sx={{border: '1px solid #e0e0e0'}}
              />
            )}
            
            {itemDetails.length > 1 && (
              <Box sx={{ 
                position: 'absolute', 
                top: 0, 
                left: 0, 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'flex-end', 
                gap: '10px', 
                padding: '10px'
              }}>
                {itemDetails.map(detail => (
                  <Button 
                    key={detail._id} 
                    variant={selectedSize === detail.itemSize ? "primaryButton" : "greyButton" }
                    onClick={(event) => handleSizeChange(detail.itemSize, event)}
                    sx={{ textTransform: 'none', opacity: selectedSize === detail.itemSize ? .8 : .6 }}
                  >
                    {detail.itemSize}
                  </Button>
                ))}
              </Box>
            )}

            {!itemImage && (
              <Box sx={{ display: 'flex', height: '194px', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ textAlign: "center", overflowWrap: 'break-word', whiteSpace: 'normal', padding: '0 20px'}}>
                  {itemIncludes}
                </Typography>
              </Box>
            )}
          </Box>

          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
              <Button sx={{ color: theme.palette.common.grey, borderColor: theme.palette.common.grey }} onClick={(event) => decrementQuantity(event)} >-</Button>
              <Typography variant="h6">{quantity}</Typography>
              <Button sx={{ color: theme.palette.common.grey, borderColor: theme.palette.common.grey }} onClick={(event) => incrementQuantity(event)} >+</Button>
            </Box>
            <Button onClick={(event) => addItemToOrder(event)} variant="primaryButton" sx={{ width: "100%", marginTop: "2rem", backgroundColor: theme.palette.primary.dark, color:theme.palette.common.white}}>
              Dodaj do koszyka
            </Button>
          </CardContent>

          <Collapse in={Boolean(expanded && itemImage)} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography sx={{ marginBottom: 2 }}>
                {{itemIncludes} ? itemIncludes : "Brak dodatkowych szczegółów"}
              </Typography>
            </CardContent>
          </Collapse>
      </Card>
    </div>
  );
}

export default FeatureCard;